// extracted by mini-css-extract-plugin
export default {"legal":"style_legal__kjy-g","legal-hr":"style_legal-hr__XE0tl","legal-title":"style_legal-title__jPEeV","legal-list":"style_legal-list__tipsd","legal-link":"style_legal-link__fdZi5"};